import React, { div } from 'react';
import { BaasicInput, BaasicSelect, BaasicCheckbox, Loader } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import _ from 'lodash';

const MarkAsShippedBulkTemplate = ({ markAsShippedBulkViewStore, t }) => {
	const {
		form,
		warehouseOptions,
		loading,
		carrierServiceOptions,
		setIsExternal,
		setCurrentValue,
	} = markAsShippedBulkViewStore;
	if (loading) return <Loader />;
	return (
		<section>
			<form className="ReactModal__form" onSubmit={form.onSubmit}>
				<div className="ReactModal__header">
					<h3 className="spc--bottom--sml">{t('MARKASSHIPPEDBULKFORM.TITLE')}</h3>
				</div>
				<div className="ReactModal__body">
					<div className="table--mark-as-shipped">
						<div className="table--mark-as-shipped__header">
							<div>{t('MARKASSHIPPEDBULKFORM.FO')}</div>
							<div>{t('MARKASSHIPPEDBULKFORM.MPO')}</div>
							<div>{t('MARKASSHIPPEDBULKFORM.EXTERNALSHIPMENT')}</div>
							<div>
								{t('MARKASSHIPPEDBULKFORM.TRACKINGNUMBER')}
								<span className="type--color--warning">*</span>
							</div>
							<div>
								{t('MARKASSHIPPEDBULKFORM.SHIPPINGCOST')}
								<span className="type--color--warning">*</span>
							</div>
							<div>{t('MARKASSHIPPEDBULKFORM.SURPLUSCHARGE')}</div>
							<div>
								{t('MARKASSHIPPEDBULKFORM.WAREHOUSE')}
								<span className="type--color--warning">*</span>
							</div>
							<div>
								{t('MARKASSHIPPEDBULKFORM.CARRIERSERVICE')}
								<span className="type--color--warning">*</span>
							</div>
						</div>
					</div>
					<div className="table--mark-as-shipped__body__wrapper">
						{form.$('fulfillmentOrders').map(item => {
							return (
								<div className="table--mark-as-shipped__body" key={item.id}>
									<div>
										<span className="type--wgt--bold">{item.$('fulfillmentOrderId').value}</span>
									</div>
									<div>
										<span>{item.$('orderNumber').value}</span>
									</div>
									<div className="align--h--center">
										<div className="display--ib">
											<BaasicCheckbox
												id={item.$('externalShipment').id}
												checked={item.$('externalShipment').value}
												onChange={evt => setIsExternal(evt, item.$('externalShipment'))}
												className="input--check input--check--no-label"
											/>
										</div>
									</div>
									<div>
										<BaasicInput noSpc disabled={item.$('externalShipment').value} field={item.$('trackingNumber')} />
									</div>
									<div>
										<BaasicInput noSpc field={item.$('shippingCost')} disabled={item.$('externalShipment').value} />
									</div>
									<div>
										<BaasicInput
											noSpc
											field={item.$('shippingCostSurcharge')}
											disabled={item.$('externalShipment').value}
										/>
									</div>
									<div>
										<BaasicSelect
											clearable={false}
											field={item.$('assignedWarehouse')}
											options={warehouseOptions.slice()}
											onChange={value => setCurrentValue(item.$('assignedWarehouse'), value)}
											value={item.$('assignedWarehouse').value}
											disabled={item.$('externalShipment').value}
										/>
									</div>
									<div>
										<BaasicSelect
											clearable={false}
											field={item.$('assignedCarrierService')}
											options={carrierServiceOptions.slice()}
											value={item.$('assignedCarrierService').value}
											onChange={value => setCurrentValue(item.$('assignedCarrierService'), value)}
											disabled={item.$('externalShipment').value}
										/>
									</div>
								</div>
							);
						})}
					</div>
					{form.error != null && <p className="type--color--warning">{translate(form.error)}</p>}
				</div>
				<div className="ReactModal__footer">
					<button className="btn btn--med btn--primary spc--bottom--sml" type="submit">
						{t('SAVE')}
					</button>
				</div>
			</form>
		</section>
	);
};

export default defaultTemplate(MarkAsShippedBulkTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/MarkAsShippedBulkTemplate.jsx